<ll-titulo>Preguntas Frecuentes</ll-titulo>
<preguntas-frecuentes [seccionesPreguntas]="seccionesPreguntas"></preguntas-frecuentes>
